import { render, staticRenderFns } from "./MantenimientoAddModal.vue?vue&type=template&id=12383062&"
import script from "./MantenimientoAddModal.vue?vue&type=script&lang=js&"
export * from "./MantenimientoAddModal.vue?vue&type=script&lang=js&"
import style0 from "./MantenimientoAddModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports